import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { LayoutMap, ZoomControls } from 'shared/ui/map/components'
import { useMap } from 'shared/ui/map/libs'

import s from './styles.module.scss'

const HotelMapPage = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const state = location.state as {
    hotelName: string
    latitude: number
    longitude: number
  } | null

  if (!state) {
    return (
      <LayoutMap
        title={t('tours_block.hotel_map_title')}
        mapError={t('tours_block.error_map_description')}
      />
    )
  }

  const { hotelName, latitude, longitude } = state

  const {
    isMapLoading,
    mapError,
    mapRef,
    handleZoomIn,
    handleZoomOut,
    handleRetry,
  } = useMap({
    center: { latitude, longitude },
    markers: [
      {
        latitude,
        longitude,
        title: hotelName,
      },
    ],
  })

  return (
    <LayoutMap
      isMapLoading={isMapLoading}
      title={hotelName}
      mapError={mapError}
      handleRetry={handleRetry}
      map={
        <div
          className={s.map}
          ref={mapRef}
        />
      }
      zoomControls={
        <ZoomControls
          handleZoomIn={handleZoomIn}
          handleZoomOut={handleZoomOut}
        />
      }
    />
  )
}

export default HotelMapPage
